import { render, staticRenderFns } from "./CompSelect.vue?vue&type=template&id=226fd7c1&scoped=true"
import script from "./CompSelect.vue?vue&type=script&lang=js"
export * from "./CompSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226fd7c1",
  null
  
)

export default component.exports